import { render, staticRenderFns } from "./mxnumtag.vue?vue&type=template&id=445eb863&scoped=true"
import script from "./mxnumtag.vue?vue&type=script&lang=js"
export * from "./mxnumtag.vue?vue&type=script&lang=js"
import style0 from "./mxnumtag.vue?vue&type=style&index=0&id=445eb863&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445eb863",
  null
  
)

export default component.exports